import { render, staticRenderFns } from "./ReplyEmailHead.vue?vue&type=template&id=5485f451&scoped=true&"
import script from "./ReplyEmailHead.vue?vue&type=script&lang=js&"
export * from "./ReplyEmailHead.vue?vue&type=script&lang=js&"
import style0 from "./ReplyEmailHead.vue?vue&type=style&index=0&id=5485f451&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5485f451",
  null
  
)

export default component.exports